import { Button, Tooltip } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
	Card,
	CardBody,
	CardHeader,
} from "../../../../_metronic/_partials/controls";
import {
	changeStatusDietVarietyLevel,
	getDietVarietyLevels,
} from "../../../../api/dietVarietyLevel";
import { getNonEmpty } from "../../../../utils/helpers";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import Table, {
	buttonsStyle,
	dateFormatter,
} from "../../../components/tables/table";

function getData(dietVarietyLevels) {
	let data = [];
	for (let i = 0; i < dietVarietyLevels.length; ++i) {
		const elem = {};
		elem.name = getNonEmpty(dietVarietyLevels[i].fullName);
		elem.description = getNonEmpty(dietVarietyLevels[i].description);
		elem.createdAt = dietVarietyLevels[i].createdAt;
		elem.id = dietVarietyLevels[i]._id;
		elem.active = dietVarietyLevels[i].active;
		data = data.concat(elem);
	}
	return data;
}

export default function DietVarietyLevelsPage() {
	const [data, setData] = useState([]);
	const [dietVarietyLevelId, setDietVarietyLevelId] = useState(null);
	const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
	const [refresh, setRefresh] = useState(false);
	const history = useHistory();
	const user = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	);

	function buttonFormatter(cell) {
		const elem = data.find((item) => item.id === cell);
		return (
			<>
				<Tooltip title="Edit">
					<Button
						style={buttonsStyle}
						size="small"
						onClick={() =>
							history.push("/edit-diet-variety-level/" + cell)
						}
					>
						<EditIcon />
					</Button>
				</Tooltip>
				{user?.role.includes("admin") && (
					<>
						<Tooltip title={elem?.active ? "Disable" : "Enable"}>
							<Button
								style={buttonsStyle}
								size="small"
								onClick={() => {
									setDietVarietyLevelId(elem);
									setOpenConfirmDialog(1);
								}}
							>
								{elem?.active ? (
									<ToggleOffIcon />
								) : (
									<ToggleOnIcon style={{ color: "red" }} />
								)}
							</Button>
						</Tooltip>
					</>
				)}
			</>
		);
	}

	const columns = [
		{ dataField: "name", text: "Full name", sort: true },
		{ dataField: "description", text: "Description", sort: true },
		{
			dataField: "createdAt",
			text: "Created at",
			formatter: dateFormatter,
			sort: true,
		},
		{ dataField: "id", text: "", formatter: buttonFormatter },
	];

	useEffect(() => {
		getDietVarietyLevels()
			.then((res) => {
				if (res.status === 200) {
					setData(getData(res.data));
					setRefresh(false);
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "Could not get diet variety levels.",
				});
			});
	}, [refresh]);

	return (
		<>
			<Card>
				<CardHeader title="Diet variety levels list"></CardHeader>
				<CardBody>
					<Table data={data} columns={columns} />
					<ConfirmDialog
						title={`Are you sure you want to ${
							dietVarietyLevelId?.active ? "disable" : "enable"
						} this diet variety level?`}
						open={openConfirmDialog === 1}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							changeStatusDietVarietyLevel(
								dietVarietyLevelId.id,
								!dietVarietyLevelId?.active
							)
								.then((res) => {
									if (res.status === 200) {
										alertSuccess({
											title: `${
												dietVarietyLevelId?.active
													? "Disabled!"
													: "Enabled!"
											}`,
											customMessage: `Diet variety level ${
												dietVarietyLevelId?.active
													? "disabled"
													: "enabled"
											} successfully`,
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage: `Could not ${
											dietVarietyLevelId?.active
												? "disable"
												: "enable"
										} diet variety level.`,
									});
								});
						}}
					/>
				</CardBody>
			</Card>
		</>
	);
}
